﻿import { TicketVisibility } from '../../enums/index';

export interface ITicketForwardRequest {
    id: number;
    ticketId: number;
    parentMessageId: number;
    createdDateTime: string;
    visibility: TicketVisibility;
    subject: string;
    message: string;
    from: string;
    to: string[];
    cc: string[];
    bcc: string[];
    files: File;
}
